import React from 'react';
import PropTypes from 'prop-types';
import ItemsGrid from '../ItemsGrid';
import PageLayout from '../PageLayout';
import './PageGrid.css';

/**
 * A reusable component for displaying a grid of items with a customizable sidebar
 * Using BEM naming convention for CSS classes
 */
const PageGrid = ({ 
  title,
  subtitle,
  fetchItems,
  renderItem,
  renderSidebar,
  placeholderText = 'Search items...',
  emptyStateMessage = 'No items found',
  itemsPerPage = 20,
  leftActions = null,
  rightActions = null,
  breadcrumbItems = null,
  topActionMenu = null,
  footer = null,
  filterFunction = null
}) => {
  return (
    <PageLayout 
      sidebar={renderSidebar()}
      breadcrumbItems={breadcrumbItems}
      topActionMenu={topActionMenu}
      footer={footer}
    >
      <ItemsGrid
        title={title}
        subtitle={subtitle}
        fetchItems={fetchItems}
        renderItem={renderItem}
        placeholderText={placeholderText}
        emptyStateMessage={emptyStateMessage}
        itemsPerPage={itemsPerPage}
        leftActions={leftActions}
        rightActions={rightActions}
        filterFunction={filterFunction}
      />
    </PageLayout>
  );
};

PageGrid.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  fetchItems: PropTypes.func.isRequired,
  renderItem: PropTypes.func.isRequired,
  renderSidebar: PropTypes.func.isRequired,
  placeholderText: PropTypes.string,
  emptyStateMessage: PropTypes.string,
  itemsPerPage: PropTypes.number,
  leftActions: PropTypes.node,
  rightActions: PropTypes.node,
  topActionMenu: PropTypes.node,
  footer: PropTypes.node,
  filterFunction: PropTypes.func,
  breadcrumbItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string
    })
  )
};

export default PageGrid;